import { combineReducers } from '@reduxjs/toolkit';
import mainFormReducer from './Steps/MainForm/signupMainFormSlice';
import confirmReducer from './Steps/Confirm/signupConfirmSlice';

const stepsReducer = combineReducers({
  main: mainFormReducer,
  confirm: confirmReducer,
})

export default stepsReducer;